import { Link } from "react-router-dom";
import "./styles.css";
// import softwareResume from "../../assets/resumes/SoftwareResume2025.pdf";

function SoftwareResume() {
  return (
    <div className="resumeContainer">
      <h1>Software Resume</h1>
      <div className="projectLinks">
        {/* <Link to={"/contact"} className="projectLink">
          contact
        </Link> */}
        <Link to={"/projects"} className="projectLink">
          projects
        </Link>
        <Link to={"/resume"} className="projectLink">
          go back
        </Link>
      </div>
    </div>
  );
}

export default SoftwareResume;
